// extracted by mini-css-extract-plugin
export default {"seasonal-pricing-heading":"seasonal-pricing-heading--mp-gjk8J","seasonalPricingHeading":"seasonal-pricing-heading--mp-gjk8J"};